

document.addEventListener('DOMContentLoaded', () => {

  const containerMenuPrestige = document.querySelector('.subMenuInnerWrap');

  if(containerMenuPrestige){
     containerMenuPrestige.addEventListener('wheel', (e) => {
            e.preventDefault(); // prevent vertical scroll
            containerMenuPrestige.scrollLeft += e.deltaY; // scroll horizontally instead
            if (e.deltaY > 0) {
                slideMenuPrestige(1);
            } else {
                slideMenuPrestige(-1);
            }

        });

        let viewport = document.querySelector('.subMenusWrap');
        let track = viewport.querySelector('.subMenuInnerWrap');
        let cards = [...track.children];
        let step = cards[1].getBoundingClientRect().width +
            parseFloat(getComputedStyle(track).columnGap || 0);
        let maxSteps = cards.length - 4;
        let maxStepsCalc = maxSteps * step;
        let offset = 0;

        computeBounds();

        window.addEventListener('resize', () => {
            computeBounds();
        });

        document.querySelector('.rightArrow')
            .addEventListener('click', () => slideMenuPrestige(1));
        document.querySelector('.leftArrow')
            .addEventListener('click', () => slideMenuPrestige(-1));

        function computeBounds() {
            viewport = document.querySelector('.subMenusWrap');
            track = viewport.querySelector('.subMenuInnerWrap');
            cards = [...track.children];
            step = cards[1].getBoundingClientRect().width +
                parseFloat(getComputedStyle(track).columnGap || 0);
            maxSteps = cards.length - 4;
            maxStepsCalc = maxSteps * step;
            offset = 0;
            
            if(track.scrollWidth <= track.parentElement.clientWidth){
                document.querySelector('.rightArrow').classList.add('hidden');
                document.querySelector('.leftArrow').classList.add('hidden');
            }

        }

        function slideMenuPrestige(direction) {

            if (direction == 1) {

                offset = Math.min(maxStepsCalc, offset + step)
            } else {
                offset = Math.max(0, offset - step);
            }

            if (offset == maxStepsCalc) {
                document.querySelector('.rightArrow').classList.add('hidden');
            } else {
                document.querySelector('.rightArrow').classList.remove('hidden');
            }

            if (offset == 0) {
                document.querySelector('.leftArrow').classList.add('hidden');
            } else {
                document.querySelector('.leftArrow').classList.remove('hidden');
            }

            track.style.setProperty('--offset', `-${offset}px`);
        }
  }


});
